import AppNotFound from './AppNotFound/containers/AppNotFoundContainer'
import PayAnyBill from './PayAnyBill/containers/PayAnyBillContainer'
import Phonereload from './Phonereload/containers/PhonereloadContainer'
import InternationalPhonereload from './InternationalPhonereload/containers/InternationalPhonereloadContainer'
import PhonereloadEzBill from './PhonereloadEzBill/containers/PhonereloadEzBillContainer'
import CashReload from './CashReload/containers/CashReloadContainer'
import CheckCashing from './CheckCashing/containers/CheckCashingContainer'

const APPS = {
  'app_billpay_anyBl': PayAnyBill,
  'app_phonereloadus_swB9P': Phonereload,
  'app_pinproducts_EX5LS': Phonereload,
  'app_phonereload_rrzQh': InternationalPhonereload,
  'app_phonereload_ezPay': PhonereloadEzBill,
  'app_cardreload_inCOM': CashReload,
  'app_cashcheck_allTR': CheckCashing
};

export const ALL_ALLOW_APPLICATIONS = APPS;

export default function getApp (app_guid) {
  if(!APPS[app_guid]) return AppNotFound;

  return APPS[app_guid]
}


// WEBPACK FOOTER //
// ./src/components/Applications/index.js